import React from 'react';
import ConsensusRevisionWidgetBuilder from './ConsensusRevisionWidgetBuilder';
import ConsensusRevisionWidgetRenderer from './ConsensusRevisionWidgetRenderer';
import Preview from './Preview';
import type { WidgetDefinition } from '../../../registry';
import type { ConsensusRevisionWidgetConfig } from './types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartLine } from '@fortawesome/free-solid-svg-icons';

export { default as ConsensusRevisionWidgetBuilder } from './ConsensusRevisionWidgetBuilder';
export { default as ConsensusRevisionWidgetRenderer } from './ConsensusRevisionWidgetRenderer';
export * from './types';

export const definition: WidgetDefinition = {
  type: 'consensus_revision',
  meta: {
    label: 'Price vs Consensus',
    icon: React.createElement(FontAwesomeIcon, { icon: faChartLine }),
    description: 'Stock price vs. consensus KPI revision (InSync estimates) with the correlation between the two',
    isSystem: true,
    isCreatable: true,
    requiresAsset: true,
    dataFlow: 'display',
  },
  dataProvider: {
    widget: 'CONSENSUS_REVISION',
    // `kpi` is driven by the Variance table's selected KPI (cross-widget) — the
    // chart re-plots the consensus revision for whichever KPI the analyst picks.
    params: [{ key: 'kpi', label: 'KPI', defaultValue: 'Total Revenue' }],
  },
  defaultSize: { w: 12, h: 8, minW: 6, minH: 5 },
  defaultConfig: () => ({} as ConsensusRevisionWidgetConfig),
  Builder: ConsensusRevisionWidgetBuilder,
  Renderer: ConsensusRevisionWidgetRenderer,
  Preview,
};
